import React, { useContext, useEffect, useState } from "react";
import "./SideMenu.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchMessageById, fetchMessages, readMessageByIds } from "../../redux/messagesSlice";
import { oauthData, selectUserInfo } from "../../redux/authSlice";
import useCustomTranslation from "../../utils/useCustomTranslation";
import { handleLogout } from "../../utils/oauthHandler";
import { STATUS_UNREAD } from "../../constants/strings";
import { Link } from "react-router-dom";
import { useGetLink } from "../../utils/useOpenLink";
import { useFilterTabs } from "../../utils/useFilterTabs";
import MessageModal from "../MessageModal";
import { WindowContext } from "../WindowResize/resize";
import MarkAllAsReadSvg from "../../assets/MarkAllAsReadSvg";

function SideMenu({ subMenuContent, closeSideMenu, colorObj, openSideMenu }) {
    const dispatch = useDispatch();

    const [expandedIndexes, setExpandedIndexes] = useState({});

    const [actualMessagesData, setActualMessagesData] = useState([]);

    const [openNotificationMenu, setOpenNotificationMenu] = useState(false);

    const [showMessageModal, setShowMessageModal] = useState(false);

    const [selectedMessage, setSelectedMessage] = useState(null);

    const { t } = useCustomTranslation();

    const { getLink } = useGetLink();

    const { isMobile } = useContext(WindowContext);

    const oauthDetails = useSelector(oauthData);
    const messages = useSelector((state) => state.messages.messages);
    const unreadMsgCount = useSelector((state) => state.messages.unreadMsgCount);
    const readMessageStatus = useSelector((state) => state.messages.readMessageStatus);
    const messageDetailsById = useSelector((state) => state.messages.messageDetails);
    const userInfo = useSelector(selectUserInfo);

    const { filteredTabs, selectType } = useFilterTabs(unreadMsgCount, 0);

    useEffect(() => {
        const selectedTab = filteredTabs.find((item) => item.isSelected)?.name;
        if (selectedTab === "Unread") {
            const unreadMessages = messages?.filter((e) => e.status === STATUS_UNREAD);

            setActualMessagesData(unreadMessages);
        } else {
            setActualMessagesData(messages || []);
        }
    }, [messages, filteredTabs]);

    const handleMarkAllAsRead = () => {
        const selectedUnreadMessageIds = actualMessagesData.map((msg) => String(msg.id));
        if (selectedUnreadMessageIds.length > 0) {
            dispatch(readMessageByIds({ messages_id: selectedUnreadMessageIds }));
        }
    };

    useEffect(() => {
        if (readMessageStatus?.success) {
            dispatch(fetchMessages());
        }
    }, [readMessageStatus]);

    return (
        <>
            <div className="hidden md:block bg-black fixed inset-0 opacity-70" />

            <div id="rightSideMenuId" className={`rightSideMenu ${openSideMenu ? "open" : ""}`}>
                <div className="RightProfileMain">
                    <div className="closeRightMenu" onClick={() => closeSideMenu()}>
                        <i className="closeRightMenu pi pi-times"></i>
                    </div>

                    <div className="userPhoto">J</div>
                    <div className="userNameMain">
                        <h3>{userInfo.name}</h3>
                        <span>
                            {t("constantString.my_profile")} <i className="pi pi-chevron-right"></i>
                        </span>
                    </div>
                </div>

                <div className="rightMenuHldr">
                    <ul>
                        <li onClick={() => setOpenNotificationMenu(true)}>
                            <i className="icon pi pi-bell"></i>
                            <span>
                                {t("constantString.notifications")}
                                {unreadMsgCount > 0 && (
                                    <div className="NotTag">
                                        {unreadMsgCount} {t("constantString.unread")}
                                    </div>
                                )}
                            </span>
                        </li>
                        {subMenuContent[0]?.contents.map((v, i) => (
                            <li key={i}>
                                <Link to={getLink(v?.content_reference)} className="flex w-full">
                                    <i className="icon pi pi-envelope"></i>
                                    <span>{v?.heading}</span>
                                </Link>
                            </li>
                        ))}
                        <li>
                            <hr></hr>
                        </li>
                        <li onClick={() => handleLogout(oauthDetails?.logoutEndpoint)}>
                            <i className="icon pi pi-sign-out"></i>
                            <span>{t("logoutText")}</span>
                        </li>
                    </ul>
                </div>
            </div>

            {openNotificationMenu && (
                <div
                    id="nofiticationMenuId"
                    className={`nofiticationMenu ${openNotificationMenu ? "open" : ""}`}
                >
                    {isMobile && (
                        <h2 className="mb-5">
                            <div className="backIconHldr">
                                <i
                                    className="backIcon pi pi-chevron-left"
                                    onClick={() => setOpenNotificationMenu(false)}
                                ></i>
                            </div>
                            <div className="closeIconHldr">
                                <i
                                    className="closeIcon pi pi-times"
                                    onClick={() => setOpenNotificationMenu(false)}
                                ></i>
                            </div>
                        </h2>
                    )}

                    <h2>
                        {t("constantString.your_notifications")}
                        <div className="closeIconHldr">
                            <span className="markRead" onClick={() => handleMarkAllAsRead()}>
                                <MarkAllAsReadSvg />
                                <span className="ml-1">{t("constantString.mark_as_all_read")}</span>
                            </span>
                            <i
                                className={`closeIcon pi pi-times ${isMobile ? "hidden" : "block"}`}
                                onClick={() => setOpenNotificationMenu(false)}
                            ></i>
                        </div>
                    </h2>

                    <div className="nav nav-tabs flex" id="nav-tab" role="tablist">
                        <>
                            {filteredTabs.map((item, index) => (
                                <button
                                    key={item.name}
                                    className={`nav-link capitalize-first-letter ${
                                        item.isSelected ? "active" : ""
                                    }`}
                                    aria-selected={item.isSelected}
                                    onClick={() => selectType(index, item.name)}
                                    style={{
                                        "--primary_color": colorObj?.primary_color,
                                    }}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </>
                    </div>

                    <ul className="unreadHldr cursor-pointer">
                        {actualMessagesData?.map((v, i) => (
                            <li key={i}>
                                <div className="unreadHeader">
                                    <div
                                        className="unreadTitleMain"
                                        onClick={() =>
                                            setExpandedIndexes((prev) => ({
                                                ...prev,
                                                [i]: !prev[i],
                                            }))
                                        }
                                        style={{
                                            "--primary_color": colorObj?.primary_color,
                                        }}
                                    >
                                        <h3>
                                            {v?.sender}
                                            <i className="pi pi-angle-right hoverArrowIcon"></i>
                                        </h3>

                                        <span className="unreadDate">{v?.message_date}</span>
                                    </div>
                                    {v?.status === 0 && (
                                        <div className="hoursAgo">
                                            <span className="dot"></span>
                                        </div>
                                    )}
                                </div>
                                {expandedIndexes[i] && (
                                    <div
                                        className="unreadSubTxt"
                                        onClick={() => {
                                            setSelectedMessage(v);
                                            setShowMessageModal(true);
                                            dispatch(fetchMessageById({ id: v?.id }));
                                        }}
                                    >
                                        {v?.subject}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {showMessageModal && selectedMessage && (
                <MessageModal
                    show={showMessageModal}
                    onClose={() => setShowMessageModal(false)}
                    messagesDetails={messageDetailsById}
                    colorObj={colorObj}
                />
            )}
        </>
    );
}

export default SideMenu;
